module.exports = __webpack_public_path__ + "static/media/match-arrow-right.f8b682f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/match-arrow-right.svg
// module id = 477
// module chunks = 7